import {
    GridToolbarExportContainer,
    GridCsvExportMenuItem,
    GridPrintExportMenuItem,
} from '@mui/x-data-grid';
import React, { Fragment } from 'react';
import { permission, services } from '../../utility/checkRoleBasedPermission';
import Permission from '../../pages/auth/permissions';
import FilteredExportMenuItem from './FilteredExportMenuItem';

const CustomExportButton = ({ service, handleFilteredExport, filteredExport, otherExports, handleOthersExport, ...props }) => {
    return (
        <Fragment>
            <Permission service={services?.[service]} permission={permission?.read}>
                <GridToolbarExportContainer {...props}>
                    {filteredExport && <FilteredExportMenuItem handleFilteredExport={handleFilteredExport} label={"Filtered rows"} />}
                    {otherExports?.length > 0 && 
                        otherExports
                        .filter((otherExport) => otherExport?.isActive)
                        .map((otherExport, index) => {
                            let { label, endpoint, dataPosition, params, exportFileName, redirectUrlOnSnackBarClick, successMessage } = otherExport;
                            exportFileName = `${exportFileName} - ${new Date()}`;
                            return (
                                <FilteredExportMenuItem 
                                    key={index} 
                                    handleFilteredExport={(event) => 
                                        handleOthersExport(event, {
                                            endpoint, dataPosition, params, exportFileName, redirectUrlOnSnackBarClick, successMessage
                                        })
                                    } 
                                    label={label}
                                />
                            );
                        })
                    }
                    <GridCsvExportMenuItem />
                    <GridPrintExportMenuItem />
                </GridToolbarExportContainer>
            </Permission>
        </Fragment>
    );
}

export default CustomExportButton;